import React from "react";

function CrossIcon({ color }) {
  return (
    <span>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="19"
          height="19"
          rx="9.5"
          fill="white"
          stroke={color ?? "#3C3C3C"}
        />
        <path
          d="M5.71436 5.71436L14.2858 14.2858M5.71436 14.2858L14.2858 5.71436L5.71436 14.2858Z"
          stroke={color ?? "#3C3C3C"}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  );
}

export default CrossIcon;
